(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-category-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-category-nav')) {
    customElements.define(
      'product-category-nav',
      class ProductCategoryNav extends HTMLElement {
        connectedCallback() {
          this.handleClick = this.handleClick.bind(this);
          this.handleDocumentClick = this.handleDocumentClick.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);

          this.addEventListener('click', this.handleClick);
          this.addEventListener('keydown', this.handleKeydown);
          document.addEventListener('click', this.handleDocumentClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.handleClick);
          this.removeEventListener('keydown', this.handleKeydown);
          document.removeEventListener('click', this.handleDocumentClick);
        }

        handleClick(event) {
          const toggle = event.target.closest('[data-category-toggle]');
          if (!toggle || !this.contains(toggle)) return;

          const key = toggle.dataset.categoryToggle;
          const shouldOpen = toggle.getAttribute('aria-expanded') !== 'true';

          this.closeAll();
          if (shouldOpen) this.setOpenState(key, true);
        }

        handleDocumentClick(event) {
          if (!this.contains(event.target)) this.closeAll();
        }

        handleKeydown(event) {
          if (event.key !== 'Escape') return;

          const openToggle = this.querySelector('[data-category-toggle][aria-expanded="true"]');
          if (!openToggle) return;

          this.closeAll();
          openToggle.focus();
        }

        setOpenState(key, isOpen) {
          const item = Array.from(this.querySelectorAll('[data-category-item]')).find(
            (candidate) => candidate.dataset.categoryItem === key
          );
          const toggle = Array.from(this.querySelectorAll('[data-category-toggle]')).find(
            (candidate) => candidate.dataset.categoryToggle === key
          );
          const desktopSubmenu = Array.from(this.querySelectorAll('[data-category-submenu]')).find(
            (candidate) => candidate.dataset.categorySubmenu === key
          );
          const mobilePanel = Array.from(this.querySelectorAll('[data-category-mobile-panel]')).find(
            (candidate) => candidate.dataset.categoryMobilePanel === key
          );

          item?.classList.toggle('is-open', isOpen);
          toggle?.setAttribute('aria-expanded', String(isOpen));
          if (desktopSubmenu) desktopSubmenu.hidden = !isOpen;
          if (mobilePanel) mobilePanel.hidden = !isOpen;
        }

        closeAll() {
          this.querySelectorAll('[data-category-toggle]').forEach((toggle) => {
            this.setOpenState(toggle.dataset.categoryToggle, false);
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
